module.exports = __webpack_public_path__ + "img/32@3x.d1d22111.png";